interface PageHeaderProps {
  title: string;
  actions?: React.ReactNode;
}

export const PageHeader = ({ title, actions }: PageHeaderProps) => (
  <div className="flex items-center justify-between mb-4.5">
    <h1 className="text-3xl font-medium text-dark-text">{title}</h1>
    {actions}
  </div>
);
